import Grid, { Grid2Props } from '@mui/material/Grid2'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { hexToRGBA } from '@repo/shared-theme-utils/font-utils'
import { generateRadialGradient } from '@repo/shared-theme-utils/style/generate-radial-gradient'
import { useResponsive } from '@repo/shared-theme-utils/hooks/useResponsive'
import { CSSProperties, ReactNode } from 'react'

export interface AdvantageBlockItem {
  title: string
  icon: ReactNode
  text: string
  style?: CSSProperties
}

export function AdvantageBlock(props: AdvantageBlockItem & { total: number; index: number }) {
  const { title, icon, text, total, index, style } = props
  const lgUp = useResponsive('up', 'lg')
  const theme = useTheme()

  let borderRadius = 'unset'

  if (total === 6) {
    if (index === 0) {
      borderRadius = lgUp ? '16px 0 0 16px' : '16px 0 0 0'
    } else if (index === 1) {
      borderRadius = lgUp ? 'unset' : '0 16px 0 0'
    } else if (index === 2) {
      borderRadius = lgUp ? 'unset' : 'unset'
    } else if (index === 3) {
      borderRadius = lgUp ? 'unset' : 'unset'
    } else if (index === 4) {
      borderRadius = lgUp ? 'unset' : '0 0 0 16px'
    } else if (index === 5) {
      borderRadius = lgUp ? '0 16px 16px 0' : '0 0 16px 0'
    }
  }

  if (total === 4) {
    if (index === 0) {
      borderRadius = lgUp ? '16px 0 0 16px' : '16px 0 0 0'
    } else if (index === 1) {
      borderRadius = lgUp ? 'unset' : '0 16px 0 0'
    } else if (index === 2) {
      borderRadius = lgUp ? 'unset' : '0 0 0 16px '
    } else if (index === 3) {
      borderRadius = lgUp ? '0 16px 16px 0' : '0 0 16px 0'
    }
  }

  if (total === 2) {
    if (index === 0) {
      borderRadius = lgUp ? '16px 0 0 16px' : '16px 16px 0 0'
    } else if (index === 1) {
      borderRadius = lgUp ? '0 16px 16px 0' : '0 0 16px 16px'
    }
  }
  return (
    <div
      style={{
        /*minWidth: '244px',*/
        margin: '-1px -1px 0 0',
        flex: '1 1',
        background: generateRadialGradient(
          [
            {
              position: 'center',
              radialSize: '50% 50%',
              color1: hexToRGBA(theme.palette.primary.main, 0.12),
              color2: hexToRGBA(theme.palette.primary.main, 0)
            }
          ],
          theme.palette.background.default
        ),
        ...style
      }}
    >
      <div
        style={{
          height: '100%',
          padding: '23px 31px',
          borderRadius,
          // border: '1px solid #1e222d',
          border: `1px solid ${theme.palette.divider}`,
          boxSizing: 'border-box'
        }}
      >
        <span style={{ color: '#2962ff', marginBottom: '12px' }}>{icon}</span>
        <Typography variant={'h4'} gutterBottom>
          {title}
        </Typography>
        <Typography variant={'h6'} color="textSecondary">
          {text}
        </Typography>
      </div>
    </div>
  )
}

export function AdvantageBlocks(props: { content: AdvantageBlockItem[] }) {
  const { content } = props
  const theme = useTheme()
  let gridProps: Grid2Props = { size: { xs: 6, md: 6, lg: 3, xl: 3 } }

  if (content.length === 6) {
    gridProps = { size: { xs: 6, md: 6, lg: 2, xl: 2 } }
  } else if (content.length === 4) {
    gridProps = { size: { xs: 6, md: 6, lg: 3, xl: 3 } }
  } else if (content.length === 2) {
    gridProps = { size: { xs: 12, md: 12, lg: 6, xl: 6 } }
  }

  return (
    <Grid container sx={{ background: theme.palette.background.default }}>
      {content.map((item, index) => (
        <Grid key={item.title} {...gridProps} sx={{ display: 'flex' }}>
          <AdvantageBlock {...item} total={content.length} index={index} />
        </Grid>
      ))}
    </Grid>
  )
}
